import axios from "axios";

export default {
  async getFeatureProfileDetails(feature_profile) {
    return axios.get("/api/feature-profile/features", {
      params: { profile: feature_profile },
    });
  },
  async getFeatureProfiles() {
    return axios.get("/api/feature-profile");
  },
  async setFeatureProfile(feature_profile) {
    return axios.post(
      "/api/feature-profile",
      {},
      { params: { profile: feature_profile } },
    );
  },
};
